/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type Judge = {
    /**
     * ID of the judge
     */
    id: string;
    /**
     * ID of the workspace
     */
    workspaceId: string;
    /**
     * ID of the project
     */
    projectId: string;
    /**
     * Slug to uniquely reference the judge within the project
     */
    slug: string;
    /**
     * Guidelines of the LLM judge
     */
    guidelines: string | null;
    /**
     * Context of the LLM judge, all additional information related to the domain the judge operates in.
     */
    context: string | null;
    /**
     * Name of the LLM judge
     */
    name: string;
    /**
     * Domains the LLM judge is operating in
     */
    domains: Array<string>;
    /**
     * Description of the LLM judge
     */
    description: string;
    /**
     * The LLM model used by this LLM judge
     */
    model: Judge.model;
    /**
     * The few-shot examples used with the judge
     */
    shots: Array<string>;
    lastActive: string | null;
    createdBy: string;
    ownerId: string;
    lastEditedBy: string;
    status: Judge.status;
    visibility: Judge.visibility;
    versionId: string | null;
    created: string;
    updated: string;
    _object: Judge._object;
};
export namespace Judge {
    /**
     * The LLM model used by this LLM judge
     */
    export enum model {
        _HF_MISTRAL_MISTRAL_7B_INSTRUCT_V0_2 = '@hf/mistral/mistral-7b-instruct-v0.2',
        _CF_META_LLAMA_3_3_70B_INSTRUCT_FP8_FAST = '@cf/meta/llama-3.3-70b-instruct-fp8-fast',
    }
    export enum status {
        DRAFT = 'draft',
        PUBLISHED = 'published',
        ARCHIVED = 'archived',
    }
    export enum visibility {
        PUBLIC = 'public',
        PRIVATE = 'private',
        UNLISTED = 'unlisted',
        WORKSPACE = 'workspace',
        WORKSPACE_AND_GUESTS = 'workspace_and_guests',
        PRIVATE_AND_GUESTS = 'private_and_guests',
        CUSTOM = 'custom',
        INTERNAL = 'internal',
    }
    export enum _object {
        JUDGE = 'judge',
    }
}

